// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */

import { LoadableAfterPaint } from '@confluence/loadable';

export const ConnectAddon = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-ConnectAddon" */ './ConnectAddon.tsx'))
			.ConnectAddon,
	name: 'ConnectAddonNext',
});

export type { ConnectAddonDescriptor } from './ConnectAddon.tsx';
